export default class TypingText extends HTMLElement {
    connectedCallback() {
        this._speed = parseInt(this.getAttribute('speed') ?? '35', 10);
        this._pause = parseInt(this.getAttribute('pause') ?? '2000', 10);
        this._delay = parseInt(this.getAttribute('delay') ?? '500', 10);
        // Loops on its own only when the `loop` attribute is present. Without it
        // the element types once and holds — the parent orchestrates re-typing.
        this._loop = this.hasAttribute('loop');
        this._fadeDuration = 300;
        this._timeouts = [];

        const text = this.textContent.trim();
        this.textContent = '';
        this._chars = [];

        text.split(' ').forEach(word => {
            const wordEl = document.createElement('span');
            wordEl.className = 'typing-word';
            word.split('').forEach(char => {
                const span = document.createElement('span');
                span.textContent = char;
                span.style.opacity = '0';
                wordEl.appendChild(span);
                this._chars.push(span);
            });
            this.appendChild(wordEl);
        });

        // When looping, run immediately so the element animates standalone.
        // Otherwise wait for the parent to call reset() / start().
        if (this._loop) this._startCycle(this._delay);
    }

    disconnectedCallback() {
        this._timeouts.forEach(t => clearTimeout(t));
        this._timeouts = [];
    }

    reset() {
        this._timeouts.forEach(t => clearTimeout(t));
        this._timeouts = [];
        this._chars.forEach(span => {
            span.style.transition = 'none';
            span.style.opacity = '0';
        });
        this._startCycle(this._delay);
    }

    _startCycle(initialDelay) {
        this._chars.forEach((span, i) => {
            const t = setTimeout(() => {
                span.style.transition = 'none';
                span.style.opacity = '1';
            }, initialDelay + i * this._speed);
            this._timeouts.push(t);
        });

        const typingDone = initialDelay + this._chars.length * this._speed;

        // Signal the parent the moment the last character is shown — this is the
        // single source of truth for orchestration timing.
        const tDone = setTimeout(() => {
            this.dispatchEvent(new CustomEvent('typing-text:done', { bubbles: true }));
        }, typingDone);
        this._timeouts.push(tDone);

        if (!this._loop) return;

        // Standalone looping: hold, fade out, retype.
        const tFade = setTimeout(() => {
            this._chars.forEach(span => {
                span.style.transition = `opacity ${this._fadeDuration}ms`;
                span.style.opacity = '0';
            });
        }, typingDone + this._pause);
        this._timeouts.push(tFade);

        const tRestart = setTimeout(
            () => this._startCycle(0),
            typingDone + this._pause + this._fadeDuration + 100
        );
        this._timeouts.push(tRestart);
    }
}
